import {useQuery} from "@tanstack/react-query";
import {GetRewardConfigsResponse, RewardsApi} from "@devour/client";

async function fetchRewardConfigs(rewardConfigIds: Array<string>): Promise<GetRewardConfigsResponse> {

    return await new RewardsApi().getRewardConfigs({
        ids: rewardConfigIds,
    });
}

function rewardConfigsQuery(rewardConfigIds: Array<string>) {
    return {
        queryKey: [
            "get-reward-configs",
            rewardConfigIds,
        ],
        queryFn: () => fetchRewardConfigs(rewardConfigIds),
        keepPreviousData: true,
        staleTime: 60000,
        refetchOnWindowFocus: false,
        enabled: rewardConfigIds && rewardConfigIds.length > 0,
    } as const;
}

export function useGetRewardConfigs(rewardConfigIds: Array<string>) {
    // const queryClient = useQueryClient();

    return useQuery(rewardConfigsQuery(rewardConfigIds));
}

